module.exports = __webpack_public_path__ + "img/servicenow.8b04cb4f.svg";